// extracted by mini-css-extract-plugin
export default {"itemData":"itemData---Hx8mo"};